import React from 'react';
import { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { isInternalURL, toBackendLang } from '@plone/volto/helpers';
import config from '@plone/volto/registry';
import { keys, isEmpty, map, filter } from 'lodash';
import { Dropdown } from 'semantic-ui-react';
import { UniversalLink, PreviewImage } from '@plone/volto/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useWindowSize } from "../../helpers";


const NavItem = ({ item, lang, mobile }) => {
  const { settings } = config;
  const size = useWindowSize();
  const subItems = filter(item.items, (item) => !item.featured_navigation)
  const subBanners = filter(item.items, 'featured_navigation')
  if (isInternalURL(item.url) || item.url === '') {
    return (
      <> 
      {(!isEmpty(item.items) && size >= 1280 && !mobile) ? (
        <Dropdown 
          text={item.title} 
          inline 
          basic
          item
          >
          
          <Dropdown.Menu className="mnPrincipal__second" >
            <Dropdown.Header >
              <NavLink
                to={item.url === '' ? '/' : item.url}
                key={item.url}
                className="item item__header"
                activeClassName="active"
                exact={
                  settings.isMultilingual
                    ? item.url === `/${toBackendLang(lang)}`
                    : item.url === ''
                }
              >
                {item.title} <FontAwesomeIcon className="ms-2" icon={faArrowRight} />
              </NavLink>
            </Dropdown.Header>

            <div className="mnPrincipal__second__wrapper">
              <div className="mnPrincipal__second__list">
                {map(subItems, (item, index) => (
                  <Dropdown.Item key={index}>
                    <UniversalLink
                      href={ item?.getRemoteUrl ? item?.getRemoteUrl : item['@id']}
                      key={item['@id']}
                      className="item__link"> 
                      {item.title}
                    </UniversalLink>
                  </Dropdown.Item>
                ))}
              </div>
               
              {!isEmpty(subBanners) && (
              <div className="mnPrincipal__banners">
                {map(subBanners, (item, index) => (
                <Dropdown.Item key={item['@id']}>
                  <UniversalLink
                    href={ item?.getRemoteUrl ? item?.getRemoteUrl : item['@id']}
                    className="mnPrincipal__banners__item">
                    {item.hasPreviewImage && (
                      <PreviewImage
                        item={item}
                        alt=''
                        className="mnPrincipal__banners__item__image"
                        sizes="(max-width: 767px) 50vw, 200px"
                        />
                    )}
                    <strong className="mnPrincipal__banners__item__text ">{item.title}</strong>                        
                  </UniversalLink>
                </Dropdown.Item>
                ))}
              </div>
              )}

            </div>
          </Dropdown.Menu>
        </Dropdown>
      ) : (
        <NavLink
          to={item.url === '' ? '/' : item.url}
          key={item.url}
          className="item"
          activeClassName="active"
          exact={
            settings.isMultilingual
              ? item.url === `/${toBackendLang(lang)}`
              : item.url === ''
          }
        >
          {item.title}
        </NavLink>
      )}
      </>
    );
  } else {
    return (
      <a
        href={item.url}
        key={item.url}
        className="item"
        rel="noopener noreferrer"
        target={settings.openExternalLinkInNewTab ? '_blank' : '_self'}
      >
        {item.title}
      </a>
    );
  }
};

export default NavItem;
